// internal imports
import { IDictionaryEntry, IDictionaryRemoveParams } from 'core/components/label/ILabel';
import IService from 'core/service/IService';
import TokenSession from 'core/util/session/TokenSession';
import { iDef } from 'core/util/TypeUtils';
import ILocalizationProvider from './ILocalizationProvider';


export default abstract class ILocalizationService implements IService, ILocalizationProvider {
	protected static DEFAULT_ID = "en_US";
	private static REGISTRY = "intl:localization";
	protected static CACHE_NAME = "dictionary";


	public getRegistry(): string {
		return ILocalizationService.REGISTRY;
	}

	public getActive(): string {

		// get user locale from the token
		const locale = TokenSession.getLocale();

		// return a service with the same id as the user locale or the default id
		return iDef(locale) ? locale : ILocalizationService.DEFAULT_ID;
	}

	public getConditions = () => undefined;

	public abstract loadEntries(language: string): Promise<object>;

	public abstract loadUserEntries(): Promise<object>;

	public abstract saveEntry(entry: IDictionaryEntry): Promise<object>;

	public abstract deleteEntry(params: IDictionaryRemoveParams): Promise<object>;

	public abstract getDictionary(): Promise<object>;

	public abstract formatDate(data: any): Date;

	public abstract formatTime(time: any): string;

	public abstract getServiceId(): string;
}



// WEBPACK FOOTER //
// ./src/core/service/localization/ILocalizationService.ts